module.exports = "<ng-content *ngIf=\"parent === null || parent.isExpanded\"></ng-content>";